import type { SubscriptionChangePreview } from '@repo/subscription/api';

import { capitalizeFirstLetter } from '../../../../utils/string';
import { getDateLabel, getIntervalName, isSameDate } from '../../utils';

export const getChangeLabel = (
  changeSubscriptionPreview: SubscriptionChangePreview | null
): string => {
  if (!changeSubscriptionPreview?.plan) {
    return '';
  }

  return `${capitalizeFirstLetter(
    changeSubscriptionPreview.plan.name.toLowerCase()
  )} ${getIntervalName(
    changeSubscriptionPreview.plan.interval
  )}ly on ${getDateLabel(changeSubscriptionPreview.changeDate)}`;
};

export const isScheduledChange = (
  changeSubscriptionPreview: SubscriptionChangePreview | null
): boolean => {
  if (!changeSubscriptionPreview) {
    return false;
  }

  const changeDate = new Date(changeSubscriptionPreview.changeDate);
  const today = new Date();

  // check that change is not happening today
  return !isSameDate(changeDate, today);
};
